import type { UiSnapshotV2 } from "@/ui/runtime/contracts/manager-ui-v2";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui/foundation/primitives/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/ui/foundation/primitives/table";
import { cn } from "@/ui/foundation/lib/utils";
import { FormResultPill, normalizeForm } from "@/ui/components/manager/manager-ui-helpers";

interface CompetitionsScreenProps {
    snapshot: UiSnapshotV2;
}

export function CompetitionsScreen({ snapshot }: CompetitionsScreenProps) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>League Table</CardTitle>
                <CardDescription>Full standings</CardDescription>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className="w-10 px-2">Pos</TableHead>
                            <TableHead>Club</TableHead>
                            <TableHead className="text-right">Played</TableHead>
                            <TableHead className="text-right">Won</TableHead>
                            <TableHead className="text-right">Drawn</TableHead>
                            <TableHead className="text-right">Lost</TableHead>
                            <TableHead className="text-right">GF</TableHead>
                            <TableHead className="text-right">GA</TableHead>
                            <TableHead className="text-right">GD</TableHead>
                            <TableHead className="text-right">Pts</TableHead>
                            <TableHead className="text-right">Form</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {snapshot.routes.competitions.leagueTable.map((row) => (
                            <TableRow key={`comp-${row.position}-${row.club}`} className={cn(row.club === snapshot.teamName ? "bg-primary/10" : "")}>
                                <TableCell className="px-2">{row.position}</TableCell>
                                <TableCell className={cn(row.club === snapshot.teamName ? "font-semibold text-primary" : "")}>{row.club}</TableCell>
                                <TableCell className="text-right">{row.played}</TableCell>
                                <TableCell className="text-right">{row.won}</TableCell>
                                <TableCell className="text-right">{row.drawn}</TableCell>
                                <TableCell className="text-right">{row.lost}</TableCell>
                                <TableCell className="text-right">{row.gf}</TableCell>
                                <TableCell className="text-right">{row.ga}</TableCell>
                                <TableCell className="text-right">{row.gd}</TableCell>
                                <TableCell className="text-right text-base font-semibold">{row.points}</TableCell>
                                <TableCell>
                                    <div className="flex justify-end gap-1">
                                        {normalizeForm(row.form).map((code, index) => (
                                            <FormResultPill key={`comp-form-${row.club}-${index}`} code={code} />
                                        ))}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
